import { Button, Drawer, Space } from "antd";
import React from "react";
import { ReactNode } from "react";
import { DrawerProps } from "antd";
interface CustomDrawerProps extends Partial<DrawerProps> {
  mask?: boolean;
  loading?: boolean;
  title?: ReactNode | string;
  className?: string;
  placement?: "left" | "right" | "top" | "bottom";
  width?: string | number;
  closable?: boolean;
  openDrawer: boolean;
  closeDrawer: (value: boolean) => void;
  footer?: boolean;
  children?: ReactNode;
}
/**
 * @author
 * @function @
 **/

export default (props: CustomDrawerProps) => {
  return (
    <Drawer
      mask={props?.mask}
      // loading={props?.loading}
      title={props?.title}
      className={props?.className}
      placement={props?.placement}
      width={props?.width ? props?.width : "378px"}
      closable={true}
      onClose={() => props?.closeDrawer(!props?.openDrawer)}
      open={props?.openDrawer}
      footer={
        !props?.footer ? (
          <div
            style={{
              textAlign: "right",
              padding: "20px",
            }}
          ></div>
        ) : null
      }
    >
      {props?.children}
    </Drawer>
  );
};
